/**
 * Newsletter Remix Lab Lesson
 * Skill Area: Communication
 * Transform one update into multichannel content
 */

import type { LessonDefinition } from '../types';
import { NEWSLETTER_REMIX_AI_PROMPT, NEWSLETTER_REMIX_CONTEXT_SCENARIOS } from '../prompts/newsletter-remix.prompt';

export const newsletterRemix: LessonDefinition = {
  id: 'newsletter-remix',
  title: 'Newsletter Remix Lab',
  displayTitle: 'Multiply Content Reach with Channel Adaptation',
  subTitle: 'Flip one update into multichannel copy.',
  persona: 'Lyra',
  skillArea: 'Communication',
  topicId: 'communication-quality',
  topicTitle: 'Communication Quality & Voice',
  topicDescription: 'Verify outputs, keep your voice authentic, and build reusable comms systems.',
  format: 'tool_lab',
  difficulty: 'Intermediate',
  estimatedMinutes: 7,
  tags: ['content', 'repurpose', 'newsletter'],
  dailyEligible: true,
  releasedAt: '2025-02-15T00:00:00.000Z',
  route: '/micro/newsletter-remix',
  storyBeat: 'Lyra repackages your update so every channel sounds intentional.',
  contextTitle: "Content starter",
  contextSummary: "Start with whatever you already wrote and let Lyra format it for supporters, partners, and quick hits.",
  contextScenarios: NEWSLETTER_REMIX_CONTEXT_SCENARIOS,
  introPrompt: "Rewriting the same update for every channel is exhausting. I'll show you how remixing works, compare the results, and help you repurpose your content.",
  steps: [
    "Select a channel you spend too much time on",
    'See a "One-off vs. Remixed" comparison',
    'Paste your core update to generate versions'
  ],
  promptGuidance: 'Choose a channel below or type your own.',
  aiPrompt: NEWSLETTER_REMIX_AI_PROMPT,
  inputPlaceholder: "Type 'Donor Emails' or your own channel...",
  quickPrompts: [
    'Donor Emails',
    'Board Updates',
    'Social Snippets',
    'Staff Slack'
  ]
};
